import React from 'react';
import Card from '@albertsons/uds/molecule/Card';
import Button from '@albertsons/uds/molecule/Button';
import EditableTable from './EditableTable';
import './FillTableCard.css';

interface FillTableCardProps {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  headers: string[];
  data: string[][];
  onDataChange: (newData: string[][]) => void;
  onCellEdit?: (rowIndex: number, columnName: string, value: string) => void;
  mandatoryFields?: string[];
  fieldTypes?: { [fieldName: string]: 'string' | 'number' | 'decimal' | 'date' | 'boolean' };
  selectedGroup?: string;
  selectedSubGroup?: string;
  selectedOrg?: string;
  onSubmit: () => void;
  onClear: () => void;
  showTable: boolean;
  onSelectedRowsChange?: (selectedRows: Set<number>) => void;
  selectedRows?: Set<number>;
  onValidationChange?: (hasErrors: boolean) => void;
}

const FillTableCard: React.FC<FillTableCardProps> = ({
  isOpen,
  setOpen,
  headers,
  data,
  onDataChange,
  onCellEdit,
  mandatoryFields = [],
  fieldTypes = {},
  selectedGroup = '',
  selectedSubGroup = '',
  selectedOrg,
  onSubmit,
  onClear,
  showTable,
  onSelectedRowsChange,
  selectedRows = new Set(),
  onValidationChange
}) => {
  const [hasValidationErrors, setHasValidationErrors] = React.useState(false);

  const handleValidationChange = (hasErrors: boolean) => {
    setHasValidationErrors(hasErrors);
    if (onValidationChange) {
      onValidationChange(hasErrors);
    }
  };
  if (!showTable) {
    return null;
  }

  return (
    <Card
      collapsible
      title="Fill Table"
      isOpen={isOpen}
      onChange={setOpen}
      className="fill-table-card"
    >
      <Card.Content>
        <EditableTable
          headers={headers}
          data={data}
          onDataChange={onDataChange}
          onCellEdit={onCellEdit}
          maxHeight="60vh"
          showEditControls={true}
          mandatoryFields={mandatoryFields}
          fieldTypes={fieldTypes}
          onValidate={() => true}
          onValidationChange={handleValidationChange}
          onSelectedRowsChange={onSelectedRowsChange}
          selectedGroup={selectedGroup}
          selectedSubGroup={selectedSubGroup}
          selectedOrg={selectedOrg}
          actionButtons={
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <div style={{ minWidth: 'auto', width: 'auto' }}>
                <Button 
                  onClick={onSubmit} 
                  disabled={selectedRows.size === 0 || hasValidationErrors}
                >
                  Submit
                </Button>
              </div>
            </div>
          }
        />
      </Card.Content>
    </Card>
  );
};

export default FillTableCard;
